export const berkeleyShelterData = [
  {
    year: 2015,
    'Berkeley total count': 834,
    'Berkeley unsheltered count': 568,
    'Berkeley sheltered count': 266,
  },
  {
    year: 2017,
    'Berkeley total count': 972,
    'Berkeley unsheltered count': 664,
    'Berkeley sheltered count': 308,
  },
  {
    year: 2019,
    'Berkeley total count': 1108,
    'Berkeley unsheltered count': 813,
    'Berkeley sheltered count': 295,
  },
];

export const lunchData = [
  {
    year: 2010,
    'School year': '2009-2010',
    'County-wide percent of students': 42.5,
    'BUSD percent of students': 41.2,
  },
  {
    year: 2011,
    'School year': '2010-2011',
    'County-wide percent of students': 42.2,
    'BUSD percent of students': 43.9,
  },
  {
    year: 2012,
    'School year': '2011-2012',
    'County-wide percent of students': 46.0,
    'BUSD percent of students': 39.1,
  },
  {
    year: 2013,
    'School year': '2012-2013',
    'County-wide percent of students': 44.4,
    'BUSD percent of students': 40.0,
  },
  {
    year: 2014,
    'School year': '2013-2014',
    'County-wide percent of students': 44.8,
    'BUSD percent of students': 41.2,
  },
  {
    year: 2015,
    'School year': '2014-2015',
    'County-wide percent of students': 43.9,
    'BUSD percent of students': 39.1,
  },
  {
    year: 2016,
    'School year': '2015-2016',
    'County-wide percent of students': 44.2,
    'BUSD percent of students': 37.3,
  },
  {
    year: 2017,
    'School year': '2016-2017',
    'County-wide percent of students': 42.6,
    'BUSD percent of students': 35.1,
  },
  {
    year: 2018,
    'School year': '2017-2018',
    'County-wide percent of students': 43.9,
    'BUSD percent of students': 34.9,
  },
  {
    year: 2019,
    'School year': '2018-2019',
    'County-wide percent of students': 43.1,
    'BUSD percent of students': 31.4,
  },
  {
    year: 2020,
    'School year': '2019-2020',
    'County-wide percent of students': 41.9,
    'BUSD percent of students': 27.2,
  },
  {
    year: 2021,
    'School year': '2020-2021',
    'County-wide percent of students': 40.5,
    'BUSD percent of students': 25.8,
  },
];

export const rentShelterData = [
  {
    year: 2010,
    'Berkeley median rent': 1159,
    'Alameda County homeless population': 4341,
    'Alameda County median rent': 1198,
  },
  {
    year: 2011,
    'Berkeley median rent': 1195,
    'Alameda County homeless population': 4178,
    'Alameda County median rent': 1244,
  },
  {
    year: 2012,
    'Berkeley median rent': 1236,
    'Alameda County homeless population': 4257,
    'Alameda County median rent': 1265,
  },
  {
    year: 2013,
    'Berkeley median rent': 1300,
    'Alameda County homeless population': 4264,
    'Alameda County median rent': 1335,
  },
  {
    year: 2014,
    'Berkeley median rent': 1375,
    'Alameda County homeless population': 4272,
    'Alameda County median rent': 1391,
  },
  {
    year: 2015,
    'Berkeley median rent': 1474,
    'Alameda County homeless population': 4040,
    'Alameda County median rent': 1513,
  },
  {
    year: 2016,
    'Berkeley median rent': 1572,
    'Alameda County homeless population': 4145,
    'Alameda County median rent': 1622,
  },
  {
    year: 2017,
    'Berkeley median rent': 1675,
    'Alameda County homeless population': 5629,
    'Alameda County median rent': 1745,
  },
  {
    year: 2018,
    'Berkeley median rent': 1800,
    'Alameda County homeless population': 5496,
    'Alameda County median rent': 1875,
  },
  {
    year: 2019,
    'Berkeley median rent': 1895,
    'Alameda County homeless population': 8022,
    'Alameda County median rent': 1982,
  },
];
